import { BetBarType } from "slotworks/components/betbar/bet-bar-component";
import Components from "slotworks/components/components";
import BetMenuMediator from "slotworks/mediators/bet-menu-mediator";
import Gamestate from "slotworks/model/game-state";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import SmartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";

export function ResetToTriggeringSpinCommand() {
    const freeSpinsWin = Gamestate.getCurrentGame().getRunningFreespinsWinTotal();

    SmartButton.setFlag(SmartButtonFlag.FREE_SPINS, false);
    SmartButton.setFlag(SmartButtonFlag.PROMPT, false);

    Components.betBar.setType(BetBarType.DEFAULT);
    Components.betBar.setEnabled(false);

    const betMenuMediator = new BetMenuMediator();
    betMenuMediator.start().execute();
    betMenuMediator.end();

    const record = Gamestate.getCurrentGame().resetRecordIndex() as SpinRecord;

    Components.betBar.winnings.setWinnings(record.creditsWon);

    record.creditsWon += freeSpinsWin;
    record.beenPaid = true;

    Components.matrix.clearStuckSymbols();

    // Can't reset reels during recovered game
    if (!Gamestate.getCurrentGame().isRecovered) {
        if (record.stops) {
            Components.matrix.jump(record.stops, record.reelset);
        } else {
            Components.matrix.jumpToGrid(record.grid);
        }
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/commands/betbar/reset-to-triggering-spin.ts